import { uniq } from 'lodash';
import { useEffect } from 'react';
import { CarrierSubmission } from 'types';
import { stringCompare } from 'utils/comparators';
import { HotjarEvents } from 'utils/hotjar-events';
import useSubmissionFilter from 'broker/components/SubmissionsView/useSubmissionFilter';
import { queueStorageKeys } from './config';

interface UseInsuredFilterProps {
  items: CarrierSubmission[];
  areItemsLoaded: boolean;
  paginationReset: () => void;
}

export function useInsuredFilter({ items, areItemsLoaded, paginationReset }: UseInsuredFilterProps) {
  const insuredFilter = useSubmissionFilter({
    baseFiltersList: [],
    storageKey: queueStorageKeys.insured,
    hotjarEvent: HotjarEvents.SubmissionsInsuredFilter,
    paginationReset,
  });

  const setInsuredFilters = insuredFilter.setFilters;

  useEffect(() => {
    if (!areItemsLoaded || items.length === 0) {
      return;
    }

    const insuredNames = uniq(
      items.filter(({ submission }) => submission?.insuredName).map(({ submission }) => submission.insuredName!),
    ).sort(stringCompare);

    setInsuredFilters((prev) =>
      insuredNames.map((name) => ({
        key: name,
        checked: prev.find((f) => f.key === name)?.checked ?? false,
        label: name,
      })),
    );
  }, [areItemsLoaded, items, setInsuredFilters]);

  return insuredFilter;
}
